import {
  shape, params, string, number, arrayOf, alias, extend, client, customType
} from '@thd-nucleus/data-sources';
import { IRGCustomProductPod } from './IRGCustomProductPod';

const Media = shape({
  image: shape({
    url: string()
  }).client(),
  images: arrayOf(shape({
    url: string(),
    type: string(),
    subType: string(),
    sizes: arrayOf(string())
  }))
});

const Product = extend({
  itemId: string(),
  dataSources: string(),
  identifiers: shape({
    brandName: string(),
    itemId: string(),
    productType: string()
  }),
  media: Media
}, IRGCustomProductPod.dataModel.product);

const WrappedProduct = shape({
  product: shape(Product)
});

const Bundle = shape({
  categories: arrayOf(shape({
    category: string(),
    itemIds: arrayOf(string())
  })),

  products: arrayOf(WrappedProduct)
});

export const dataModel = {
  dynamicRecs: params({
    itemId: string().isRequired(),
    storeId: string(),
    loyaltyMembershipInput: customType('LoyaltyMembershipInput').shape({
      svocID: string(),
      programTiers: arrayOf(shape({
        tier: string(),
        program: string()
      }))
    })
  }).shape({
    irg: params({ maxItems: number() }).shape({
      collection: Bundle,
      accessories: Bundle
    })
  })
};
